export default __webpack_public_path__ + "static/media/logo.040f9c51.png";